<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Garaj</label>
            <v-select-list placeholder="Garaj" v-model="garage" label="GarageName" :options="garages"/>
        </div>
        <div class="col-md-12 mb-1">
            <label class="form-label">Firma</label>
            <v-select-list v-model="firm" :options="firms" v-on:input="getFirmLocation" label="Name" v-on:search="searchFirms" placeholder="Firma" :loading="firmsLoading"></v-select-list>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Görev Yeri</label>
            <v-select-list :disabled="!firm || locations.length == 0" placeholder="Görev Yeri" v-model="location" label="LocationName" :options="locations"/>
        </div>
    </div>
</template>

<script>
import {BSpinner} from 'bootstrap-vue'
import VehicleOperationsApi from '@/api/vehicle-operations'
import FirmOperationsApi from '@/api/firm-operations'
export default {
    components:{
        BSpinner
    },
    props:{
        value:Object,
    },
    data(){
        return {
            garages:[],
            firms:[],
            firmsLoading:false,
            locations:[],
        }
    },
    mounted(){
        this.getGarages()
        if(this.value.DutyFirm){
            let locationId = structuredClone(this.value.DutyFirmLocationId)
            this.searchFirms(this.value.DutyFirm).then(res=>{
                this.firm = this.firms.find(f=>f.Id==this.value.DutyFirmId)
                this.getFirmLocation().then(res=>{
                    this.location = this.locations.find(l=>l.Id==locationId)
                })
            })
        }
    },
    watch:{
        firm(){
            this.location = null
        }
    },
    methods:{
        getGarages(){
            VehicleOperationsApi.Garage.List().then(response=>{
                this.garages = response.data.Data
            })
        },
        getFirmLocation(){
            return new Promise((resolve)=>{
                if(this.firm?.Id){
                    FirmOperationsApi.Location.List(this.firm.Id).then(response=>{
                        this.locations = response.data.Data
                        resolve()
                    })
                }
            })
        },
        searchFirms(search){
            return new Promise((resolve)=>{
                if(search){
                    this.firmsLoading = true
                    FirmOperationsApi.List(search)
                    .then(res=>{
                        this.firms = res.data.Data
                        this.firmsLoading = false
                        resolve()
                    }).catch(err=>{ this.firmsLoading = false })
                }
            })
        },
    },
    computed:{
        garage:{
            get:function(){
                return this.garages.find(b=>b.Id==this.value.VehicleInventoryGarageId)
            },
            set:function(value){
                this.value.VehicleInventoryGarageId = value?.Id || null
            }  
        },
        firm:{
            get:function(){
                return this.firms.find(b=>b.Id==this.value.DutyFirmId)
            },
            set:function(value){
                this.value.DutyFirmId = value?.Id || null
            }  
        },
        location:{
            get:function(){
                return this.locations.find(b=>b.Id==this.value.DutyFirmLocationId)
            },
            set:function(value){
                this.value.DutyFirmLocationId = value?.Id || null
            }  
        }
    }
}
</script>

<style lang="scss">
</style>